import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Toolbar } from '@mui/material';
import { Home, Person, Settings, Assignment, Inventory, Loyalty, AccountBox, ListAlt } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const drawerWidth = 300; // サイドメニューの幅を300に設定

const Sidebar: React.FC = () => {
  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
    >
      <Toolbar />
      <Divider />
      <List>
        <ListItem button component={Link} to="/dashboard">
          <ListItemIcon><Home /></ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        <Divider />

        <Divider />
        <ListItem>
          <ListItemIcon><ListAlt /></ListItemIcon>
          <ListItemText primary="登録クリニック一覧(準備中)" />
        </ListItem>
        <ListItem>
          <ListItemIcon><AccountBox /></ListItemIcon>
          <ListItemText primary="アカウント発行/クリニック(準備中)" />
        </ListItem>
        <ListItem button component={Link} to="/dashboard/dr-account-list">
          <ListItemIcon><ListAlt /></ListItemIcon>
          <ListItemText primary="登録ドクター一覧" />
        </ListItem>
        <ListItem button component={Link} to="/dashboard/dr-account">
          <ListItemIcon><AccountBox /></ListItemIcon>
          <ListItemText primary="アカウント発行/ドクター" />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
